import { PhotoForm } from './constants';
import { PhotosResultDataById, VesselResultDataById } from './types';

export function setPhotoValues(photoData:PhotosResultDataById, setValue: SetValue, vesselDataById: VesselResultDataById[]) {
  const vesselData = vesselDataById?.find((item) => (item?.Value?.trim()?.toLowerCase() === photoData?.VesselName?.trim()?.toLowerCase()
      || item?.Text?.trim()?.toLowerCase() === photoData?.VesselName?.trim()?.toLowerCase()));
  setValue(PhotoForm.jobOrder, photoData?.JobOrder);
  setValue(PhotoForm.vessel, vesselData?.Value || null);
  setValue(PhotoForm.description, photoData.Comment || '');
}
